module.exports = __webpack_public_path__ + "static/media/digi-drive-logo.666b5822.svg";